import {MILLIS_OF_SECOND, MINS_OF_HOUR, SECONDS_OF_MIN} from './timeConsts';

export const IMPORTANT_MESSAGES_COOKIE_PREFIX = 'important-modal-id';
const HOURS = 72;
const EXP_COOKIE_TIME = HOURS * MINS_OF_HOUR * SECONDS_OF_MIN * MILLIS_OF_SECOND; // 72 hours expiration date

export const importantMessagesCookieExists = (cookies, eventId) => {
  return !!cookies.get(`${IMPORTANT_MESSAGES_COOKIE_PREFIX}-${eventId}`);
};

export const setImportantMessagesCookie = (cookies, eventId) => {
  const exp = new Date();
  exp.setTime(exp.getTime() + EXP_COOKIE_TIME);
  cookies.set(`${IMPORTANT_MESSAGES_COOKIE_PREFIX}-${eventId}`, 1, {expires: exp});
};
